var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_content"},[_c('div',{staticClass:"content_item_one"},[_c('div',{ref:"echartMap",attrs:{"id":"myChart"}})]),_c('div',{staticClass:"content_item_two"})])}
var staticRenderFns = []

export { render, staticRenderFns }